import {useRef,useState,type FormEvent} from 'react';

import {DateOnlyInput} from '../components/DateOnlyInput';
import {api} from '../api';

import {withBuildingScope} from '../ui/building-scope';

import {AdvancedDetails} from '../ui/AdvancedDetails';

import {ErrorState} from '../ui/State';


export function HistoricalRepairCompletion({id,version,building,onChanged}:{id:string;
version:number;
building:string;
onChanged:()=>void}){
 const [busy,setBusy]=useState(false),[error,setError]=useState<unknown>(),[saved,setSaved]=useState(false);

 const pending=useRef<{key:string;
body:{version:number;
reason:string;
confirmation:string;
completedOn:string|null;
allWorkComplete:true}}|undefined>(undefined);

 async function submit(event:FormEvent<HTMLFormElement>){event.preventDefault();
if(busy)return;

  const form=new FormData(event.currentTarget);

  pending.current??={key:crypto.randomUUID(),body:{version,reason:String(form.get('reason')??'').trim(),confirmation:String(form.get('confirmation')??'').trim(),completedOn:String(form.get('completedOn')??'')||null,allWorkComplete:true}};

  setBusy(true);
setError(undefined);
const operation=pending.current;

  try{const result=await api<{id:string;
status:string;
version:number}>(withBuildingScope(`/api/work/cases/${id}/historical-completion`,building),{method:'POST',headers:{'idempotency-key':operation.key},body:JSON.stringify(operation.body)});

   if(result.id!==id||result.status!=='Completed'||result.version!==operation.body.version+1)throw Error('Completion was not confirmed. Retry to check the same operation.');

   setSaved(true);
onChanged();

  }catch(value){setError(value);
}finally{setBusy(false);
}
 }
 if(saved)return <p role="status">Historical repair formally completed. Financial and linked records remain unchanged.</p>;

 return <AdvancedDetails summary="Close historical completed repair"><section aria-label="Historical repair completion"><h2>Close historical completed repair</h2>
  <p>Use your administrator confirmation for repair work already completed outside the recorded order process. This records completion without creating an order or claiming an inspection. Invoices, payments, findings and other linked work remain unchanged.</p>
  <form onSubmit={event=>void submit(event)}><fieldset disabled={busy||Boolean(pending.current)}>
   <label>Reason for historical closure<textarea name="reason" required minLength={20} maxLength={2000}/></label>
   <label>Completion confirmation and evidence<textarea name="confirmation" required minLength={20} maxLength={4000}/></label>
   <label>Actual completion date, if known<DateOnlyInput name="completedOn"/></label>
   <p>Leave the actual date blank if unknown. The audit records when you close the repair separately.</p>
   <label><input name="allWorkComplete" type="checkbox" required/>All repair work in this record is complete;
 outstanding repair scopes are retained separately.</label>
  </fieldset><button type="submit" disabled={busy}>{busy?'Closing…':pending.current?'Retry historical closure':'Confirm historical completion'}</button></form>
  {Boolean(error)&&<><ErrorState error={error}/><p>Your original closure details are retained for a safe retry. Refresh the page to review the latest record before changing those details.</p></>}
 </section></AdvancedDetails>;

}
